import { render, staticRenderFns } from "./TokenDetail.m.vue?vue&type=template&id=f6ac8392&scoped=true"
import script from "./TokenDetail.m.vue?vue&type=script&lang=js"
export * from "./TokenDetail.m.vue?vue&type=script&lang=js"
import style0 from "./TokenDetail.m.vue?vue&type=style&index=0&id=f6ac8392&prod&lang=scss&scoped=true"
import style1 from "./TokenDetail.m.vue?vue&type=style&index=1&id=f6ac8392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ac8392",
  null
  
)

export default component.exports